import { render, staticRenderFns } from "./ChamadoProp.vue?vue&type=template&id=7f275c22"
import script from "./ChamadoProp.vue?vue&type=script&lang=js"
export * from "./ChamadoProp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports